import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { mediaQueries } from '@general/breakpoints';

const CompanyProfileAvatar = styled.div`
    height: ${props => props.sizeMobile}px;
    width: ${props => props.sizeMobile}px;
    @media ${mediaQueries.md} {
        height: ${props => props.sizeDesktop}px;
        width: ${props => props.sizeDesktop}px;
    }
`;

const CardCompanyProfileAvatar = ({ photoURL, companyName, sizeMobile = 80, sizeDesktop = 180 }) => (
    <>
        {photoURL && (
            <CompanyProfileAvatar sizeDesktop={sizeDesktop} sizeMobile={sizeMobile}>
                <img
                    src={`${photoURL}?v=${Date.now()}`}
                    alt={companyName}
                    style={{ borderRadius: '100%', width: '100%', height: '100%' }}
                />
            </CompanyProfileAvatar>
        )}

        {!photoURL && (
            <CompanyProfileAvatar sizeDesktop={sizeDesktop} sizeMobile={sizeMobile}>
                <div
                    alt={companyName}
                    style={{ borderRadius: '100%', width: '100%', height: '100%' }}
                    className="member-default d-flex align-items-center"
                >
                    <img
                        src="/assets/images/icsc-rgb-icons/icsc-rgb-big-box-store.png"
                        alt=""
                        className="member-card-img mx-auto mt-3"
                    />
                </div>
            </CompanyProfileAvatar>
        )}
    </>
);

CardCompanyProfileAvatar.propTypes = {
    companyName: PropTypes.string.isRequired,
    photoURL: PropTypes.string,
    sizeMobile: PropTypes.number,
    sizeDesktop: PropTypes.number,
};

export default CardCompanyProfileAvatar;
